import React from 'react';
import { GUARDIAN_FEED_PHOTOS } from '../config/siteConfig';
import { useLanguage } from '../i18n/LanguageContext';
import { CollapsibleSection } from './CollapsibleSection';

export const MemeWall = ({ isOpen, onToggle }) => {
  const { t } = useLanguage();

  return (
    <CollapsibleSection
      id="feed-section"
      eyebrow={t('feedLabel')}
      title={t('feedHeading')}
      isOpen={isOpen}
      onToggle={onToggle}
      testId="guardian-feed-toggle"
    >
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {GUARDIAN_FEED_PHOTOS.map((meme, index) => (
          <figure
            key={index}
            className="overflow-hidden rounded-2xl border border-slate-700/50 bg-slate-900/60"
          >
            {meme.image ? (
              <div className="w-full h-64 overflow-hidden bg-slate-800">
                <img
                  src={`${meme.image}?w=1200&h=800&fit=crop&q=90`}
                  alt={meme.alt}
                  loading="lazy"
                  width="600"
                  height="400"
                  className="w-full h-full object-cover"
                />
              </div>
            ) : (
              <div className="w-full h-64 bg-gradient-to-br from-slate-800 to-slate-900 flex items-center justify-center relative overflow-hidden">
                <div className="absolute inset-0 opacity-5">
                  <div className="absolute top-10 right-10 w-32 h-32 rounded-full bg-white" />
                  <div className="absolute bottom-10 left-10 w-40 h-40 rounded-full bg-white" />
                </div>
                <span className="text-5xl opacity-10 relative z-10">🐾</span>
              </div>
            )}
          </figure>
        ))}
      </div>
    </CollapsibleSection>
  );
};
